import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import {
    FreightForwarder,
} from 'app/Apps/OrderManagement/FreightForwarders/FreightForwarders.types'

import requests from 'app/requests/FreightForwarder.request'

const useGetFreightForwarder = (id: number) => {
    return useRequest<FreightForwarder>({
        key: RequestKeys.getFreightForwarder,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}

export default useGetFreightForwarder
